import { render, staticRenderFns } from "./SingleGradeEdit.vue?vue&type=template&id=2cbd2e40&scoped=true"
import script from "./SingleGradeEdit.vue?vue&type=script&lang=js"
export * from "./SingleGradeEdit.vue?vue&type=script&lang=js"
import style0 from "./SingleGradeEdit.vue?vue&type=style&index=0&id=2cbd2e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbd2e40",
  null
  
)

export default component.exports